import {NgModule, TransferState} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {LoaderComponent} from './common-component/loader/loader.component';
import {sharedModule} from './shared/shared.module';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {environment} from 'src/environments/environment';
import {NgxSpinnerModule} from "ngx-spinner";
import {NgxMatTimepickerModule} from "ngx-mat-timepicker";
import {SafePipe} from 'safe-pipe';
import {GoogleMapsModule} from '@angular/google-maps'

import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatNativeDateModule} from '@angular/material/core';

import {MsalGuard, MsalInterceptor, MsalModule, MsalService,} from "@azure/msal-angular";
import {BrowserCacheLocation, InteractionType, LogLevel, PublicClientApplication} from "@azure/msal-browser";
import {HTTP_INTERCEPTORS} from "@angular/common/http";
import {AuthModule} from './auth/auth.module';
import {AlertAndErrorService} from "./core/interceptor/alert-error/alert-and-error.service";
import {SpinnerInterceptor} from "./core/interceptor/spinner/spinner.interceptor";
import {HttpClientModule} from "./shared/http-client/http-client.module";
import {ToastrModule} from "ngx-toastr";
import {ToasterAlertComponent} from "./shared/toaster-alert/toaster-alert.component";


@NgModule({
    declarations: [AppComponent, LoaderComponent, ToasterAlertComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        AppRoutingModule,
        NgxSpinnerModule,
        MsalModule.forRoot(
            new PublicClientApplication({
                auth: {
                    clientId: environment.clientId,
                    authority: environment.authority,
                    redirectUri: environment.redirectUri,
                    postLogoutRedirectUri: environment.loginFailedRoute,
                    navigateToLoginRequestUrl: true
                },
                cache: {
                    cacheLocation: BrowserCacheLocation.LocalStorage,
                    storeAuthStateInCookie: true,
                },
                system: {
                    loggerOptions: {
                        loggerCallback: (logLevel, message, containsPii) => {
                        },
                        piiLoggingEnabled: false,
                        logLevel: LogLevel.Trace,
                    },
                }
            }),
            {
                interactionType: InteractionType.Redirect,
                loginFailedRoute: environment.loginFailedRoute,
                authRequest: {
                    scopes: ["user.read"],
                },
            },
            {
                interactionType: InteractionType.Redirect,
                protectedResourceMap: new Map([
                    ["https://graph.microsoft.com/v1.0/me", ["user.read"]],
                    [environment.baseUrl+'*', ['api://08aecf67-3ddb-4ccd-9cc6-67a83e1bd8dc/app']],
                    // ['ws://localhost:8080/ws-chat/**', ['api://08aecf67-3ddb-4ccd-9cc6-67a83e1bd8dc/app']]
                ]),
            }
        ),
        sharedModule,
        NgxMatTimepickerModule,
        SafePipe,
        GoogleMapsModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatInputModule,
        MatNativeDateModule,
        AuthModule,
        ToastrModule.forRoot({
            timeOut: 5000,
            closeButton: true,
            toastComponent: ToasterAlertComponent,
            newestOnTop: false,
            disableTimeOut: false,
            tapToDismiss: false,
        }),
    ],
    exports: [],
    bootstrap: [AppComponent],
    providers:
        [
            MsalService,
            MsalGuard,
            {
              provide: HTTP_INTERCEPTORS,
              useClass: MsalInterceptor,
              multi: true
            },
            {provide: HTTP_INTERCEPTORS, useClass: AlertAndErrorService, multi: true},
            {provide: HTTP_INTERCEPTORS, useClass: SpinnerInterceptor, multi: true},
            // {provide: HTTP_INTERCEPTORS, useClass: WebSocketInterceptor, multi: true},
        ],

})
export class AppModule {
}
